<template>
<svg class="cnm-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="7.8667" width="16" height="3" fill="black"/>
<rect x="4" y="14.8667" width="16" height="3" fill="black"/>
</svg>
</template>